import { gql } from 'apollo-angular';
import {
  PROJECT_INSTALLMENT_FUNDING_CONDITION_FRAGMENT,
  PROJECT_INSTALLMENT_FUNDING_FRAGMENT
} from "./getEquityInstallments";


export var update_equity_installment = gql`
    mutation updateEquityInstallment($id: ID!, $input: UpdateProjectInstallmentInput){
      updateProjectInstallment(id: $id, input: $input){
        id
        project {
          id
          name
        }
        installment_number
        installment_amount
        total_funded_amount
        total_adjuster_amount
        total_remaining_amount
        notes
        status_date
        certificated
        projectInstallmentStatus{
          id
          name
        }
        original_commitment_date
        original_installment_amount
        projectInstallmentFundings {
          ...ProjectInstallmentFundingFields
        }
      }
    }
    ${PROJECT_INSTALLMENT_FUNDING_FRAGMENT}
`

export var create_equity_installment = gql`
    mutation createEquityInstallment($project_id: ID!, $input: CreateProjectInstallmentInput){
      upsertProjectInstallment(project_id: $project_id, input: $input)
    }
`
// export var create_equity_installment = gql`
//     mutation createEquityInstallment($project_id: ID!, $input: CreateProjectInstallmentInput){
//       createProjectInstallment(project_id: $project_id, input: $input){
//         id
//         project {
//           id
//           name
//         }
//         installment_number
//         installment_amount
//         total_funded_amount
//         total_adjuster_amount
//         total_remaining_amount
//         notes
//         status_date
//         certificated
//         projectInstallmentStatus{
//           id
//           name
//         }
//         original_commitment_date
//         original_installment_amount
//         projectInstallmentFundings {
//           ...ProjectInstallmentFundingFields
//         }
//       }
//     }
//     ${PROJECT_INSTALLMENT_FUNDING_FRAGMENT}
// `

export var delete_equity_installment = gql`
    mutation deleteEquityInstallment($id: ID!){
      deleteProjectInstallment(id: $id){
        id
        project {
          id
          name
        }
        installment_number
        installment_amount
        total_funded_amount
        total_adjuster_amount
        total_remaining_amount
        notes
        status_date
        certificated
        projectInstallmentStatus{
          id
          name
        }
        original_commitment_date
        original_installment_amount
        projectInstallmentFundings {
          ...ProjectInstallmentFundingFields
        }
      }
    }
    ${PROJECT_INSTALLMENT_FUNDING_FRAGMENT}
`

export var create_installment_funding = gql`
    mutation createProjectInstallmentFunding($input: CreateInstallmentFundingInput!){
      createProjectInstallmentFunding(input: $input){
        ...ProjectInstallmentFundingFields
      }
    }
    ${PROJECT_INSTALLMENT_FUNDING_FRAGMENT}
`

export var update_installment_funding = gql`
    mutation updateProjectInstallmentFunding($id: ID!, $input: UpdateInstallmentFundingInput)
    {
      updateProjectInstallmentFunding(id: $id, input: $input
      ){
        ...ProjectInstallmentFundingFields
      }
    }
    ${PROJECT_INSTALLMENT_FUNDING_FRAGMENT}
`

export var delete_installment_funding = gql`
    mutation deleteProjectInstallmentFunding($id: ID!)
    {
      deleteProjectInstallmentFunding(id: $id){
        ...ProjectInstallmentFundingFields
      }
    }
    ${PROJECT_INSTALLMENT_FUNDING_FRAGMENT}
`

export var create_project_installment_funding_condition = gql`
    mutation createProjectInstallmentCondition($input: CreateProjectInstallmentConditionInput!){
      createProjectInstallmentCondition(input: $input){
        ...ProjectInstallmentFundingConditionFields
      }
    }
    ${PROJECT_INSTALLMENT_FUNDING_CONDITION_FRAGMENT}
`
export var update_project_installment_funding_condition = gql`
    mutation updateProjectInstallmentCondition($id: ID!, $input: UpdateProjectInstallmentConditionInput){
      updateProjectInstallmentCondition(id: $id, input: $input){
        ...ProjectInstallmentFundingConditionFields
      }
    }
    ${PROJECT_INSTALLMENT_FUNDING_CONDITION_FRAGMENT}
`
export var delete_project_installment_funding_condition = gql`
    mutation deleteProjectInstallmentCondition($id: ID!){
      deleteProjectInstallmentCondition(id: $id){
        ...ProjectInstallmentFundingConditionFields
      }
    }
    ${PROJECT_INSTALLMENT_FUNDING_CONDITION_FRAGMENT}
`

export var create_funding_condition_file = gql`
    mutation createConditionFile($input: CreateConditionFileInput!){
      createConditionFile(input: $input){
        id
        filename
        fileurl
        include_in_package
        projectInstallmentFundingCondition{
          id
        }
      }
    }
`

export var update_include_in_package_status = gql`
    mutation updateFilePackageStatus($id: ID!, $include_in_package: Boolean!){
      updateFilePackageStatus(id: $id, include_in_package: $include_in_package){
        id
      }
    }
`
export var delete_condition_file = gql`
  mutation deleteConditionFile($id:ID!)
  {
    deleteConditionFile(id: $id){
      id
    }
  }
  `

export var delete_package = gql`
    mutation removePackage($id: ID!){
      removePackage(id: $id){
        id
      }
    }
`

export var create_condition_approval = gql`
    mutation createConditionApproval($input: CreateConditionApprovalInput!){
      createConditionApproval(input: $input){
        id
        user {
          person {
            name
          }
        }
        approval_status_date
        projectInstallmentFundingCondition {
          id
        }
        projectInstallmentFundingConditionApprovalStatus {
          id
          name
        }
        projectInstallmentFundingConditionApprovalType {
          id
          name
        }

      }
    }
`
export var update_condition_approval = gql`
    mutation updateConditionApproval($id: ID!, $project_installment_funding_condition_approval_status_id: ID!, $user_id: ID!){
      updateConditionApproval(id: $id, project_installment_funding_condition_approval_status_id: $project_installment_funding_condition_approval_status_id, user_id: $user_id){
        id
        user {
          person {
            name
          }
        }
        approval_status_date
        projectInstallmentFundingCondition {
          id
        }
        projectInstallmentFundingConditionApprovalStatus {
          id
          name
        }
        projectInstallmentFundingConditionApprovalType {
          id
          name
        }
      }
    }
`

export var delete_condition_approval = gql`
    mutation deleteConditionApproval($id: ID!){
      deleteConditionApproval(id: $id){
        id
        user {
          person {
            name
          }
        }
        approval_status_date
        projectInstallmentFundingCondition {
          id
        }
        projectInstallmentFundingConditionApprovalStatus {
          id
          name
        }
        projectInstallmentFundingConditionApprovalType {
          id
          name
        }
      }
    }
`

export var generate_installment_funding_payments = gql`
    mutation generateInstallmentFundingPayments($project_installment_funding_id: ID!){
      generateInstallmentFundingPayments(project_installment_funding_id: $project_installment_funding_id)
    }
`

export var update_installment_funding_payment = gql`
    mutation updateInstallmentFundingPayment($id: ID!, $amount: Float, $adjuster: Float){
      updateFundingPayment(id: $id, amount: $amount, adjuster: $adjuster){
        id
      }
    }
`

export var delete_installment_funding_payment = gql`
    mutation deleteInstallmentFundingPayment($id: ID!){
      deleteFundingPayment(id: $id){
        id
      }
    }
`

export var insert_refresh_sso_token = gql`
    mutation insertSsoToken($user_id: ID!, $refresh_token: String!, $access_token: String!, $last_verified: DateTime!, $active: Boolean!){
      insertSsoToken(user_id: $user_id, refresh_token: $refresh_token, access_token: $access_token, last_verified: $last_verified, active: $active){
        access_token
        refresh_token
      }
    }
`

export const generate_package = gql`
  mutation generatePackage($project_installment_funding_id: ID!){
    createPackage(project_installment_funding_id: $project_installment_funding_id)
  }
`;
